import dynamic from 'next/dynamic';
import BirthdayProductsList from './birthday-products-list';
import CountdownSkeleton from './birthday-countdown/countdown-skeleton';
const BirthdayCountdown = dynamic(() => import('./birthday-countdown'), {
  ssr: false,
  loading: () => <CountdownSkeleton />
});
const BirthdayCustomComponents = () => <>
        <BirthdayCountdown data-sentry-element="BirthdayCountdown" data-sentry-source-file="index.tsx" />
        <BirthdayProductsList data-sentry-element="BirthdayProductsList" data-sentry-source-file="index.tsx" />
    </>;
export default BirthdayCustomComponents;